import { Users, TrendingUp, FileText, Layers } from 'lucide-react';

export const INSTRUMENT_TEMPLATES = [
  {
    id: 'common_units',
    name: 'Common Units',
    description: 'Standard equal-rights investment units with pro-rata distributions',
    icon: Users,
    color: 'bg-blue-100 text-blue-700',
    defaults: {
      security_class: 'common',
      distribution_rights: 'pro_rata',
      voting_rights: false,
      transferable: true,
      unit_price_at_issuance: '1',
      currency: 'EUR',
    },
  },
  {
    id: 'preferred_shares',
    name: 'Preferred Shares',
    description: 'Priority units with preferential distribution rights',
    icon: TrendingUp,
    color: 'bg-purple-100 text-purple-700',
    defaults: {
      security_class: 'preferred',
      distribution_rights: 'pro_rata',
      voting_rights: true,
      transferable: true,
      unit_price_at_issuance: '10',
      currency: 'EUR',
      transfer_restrictions: 'Subject to board approval',
    },
  },
  {
    id: 'debt_instrument',
    name: 'Debt Instrument',
    description: 'Fixed-return debt securities with defined maturity',
    icon: FileText,
    color: 'bg-amber-100 text-amber-700',
    defaults: {
      security_class: 'debt',
      distribution_rights: 'fixed',
      voting_rights: false,
      transferable: false,
      unit_price_at_issuance: '100',
      currency: 'EUR',
      redemption_terms: 'Redeemable at par on maturity date',
    },
  },
  {
    id: 'convertible_note',
    name: 'Convertible Note',
    description: 'Debt that can convert to equity at defined terms',
    icon: Layers,
    color: 'bg-emerald-100 text-emerald-700',
    defaults: {
      security_class: 'convertible',
      distribution_rights: 'none',
      voting_rights: false,
      transferable: true,
      unit_price_at_issuance: '1',
      currency: 'EUR',
      transfer_restrictions: 'Conversion rights subject to triggering events',
    },
  },
];

export const EMPTY_INSTRUMENT_FORM = {
  name: '',
  security_class: 'common',
  total_authorized_units: '',
  unit_price_at_issuance: '1',
  currency: 'EUR',
  distribution_rights: 'pro_rata',
  voting_rights: false,
  transferable: true,
  transfer_restrictions: '',
  redemption_terms: '',
  project_id: '',
  // Offering terms (the instrument IS the offering)
  offering_status: 'draft',
  min_subscription_units: '1',
  max_subscription_units: '',
  subscription_start: '',
  subscription_end: '',
  soft_cap: '',
  hard_cap: '',
  // Financial terms
  min_hold_period_months: '',
  max_hold_period_months: '',
  payout_terms: '',
  target_hold_months: '',
  estimated_monthly_noi_pct: '',
  estimated_total_appreciation_pct: '',
  project_start_date: '',
  project_exit_date: '',
  fee_percent: '2.5',
};

export const toFormData = (instrument) => ({
  ...EMPTY_INSTRUMENT_FORM,
  name: instrument.name || '',
  security_class: instrument.security_class || 'common',
  total_authorized_units: instrument.total_authorized_units?.toString() || '',
  unit_price_at_issuance: instrument.unit_price_at_issuance || instrument.unit_price || '1',
  currency: instrument.currency || 'EUR',
  distribution_rights: instrument.distribution_rights || 'pro_rata',
  voting_rights: instrument.voting_rights || false,
  transferable: instrument.transferable !== false,
  transfer_restrictions: instrument.transfer_restrictions || '',
  redemption_terms: instrument.redemption_terms || '',
  project_id: instrument.project_id || '',
  offering_status: instrument.offering_status || 'draft',
  min_subscription_units: (instrument.min_subscription_units ?? 1).toString(),
  max_subscription_units: instrument.max_subscription_units?.toString() || '',
  subscription_start: instrument.subscription_start ? instrument.subscription_start.slice(0, 10) : '',
  subscription_end: instrument.subscription_end ? instrument.subscription_end.slice(0, 10) : '',
  soft_cap: instrument.soft_cap || '',
  hard_cap: instrument.hard_cap || '',
  target_hold_months: instrument.target_hold_months?.toString() || '',
  estimated_monthly_noi_pct: instrument.estimated_monthly_noi_pct?.toString() || '',
  estimated_total_appreciation_pct: instrument.estimated_total_appreciation_pct?.toString() || '',
  min_hold_period_months: instrument.min_hold_period_months?.toString() || '',
  max_hold_period_months: instrument.max_hold_period_months?.toString() || '',
  payout_terms: instrument.payout_terms || '',

  project_start_date: instrument.project_start_date ? instrument.project_start_date.split('T')[0] : '',
  project_exit_date: instrument.project_exit_date ? instrument.project_exit_date.split('T')[0] : '',
  fee_percent: instrument.fee_percent || '2.5',
});
